import React, { useEffect, useMemo, useRef, useReducer, useState } from 'react';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'; 
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { BotonExportarExcel } from '../../components/buttons/BotonExportarExcel';
import { BotonGeneral } from '../../components/buttons/BotonGeneral';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { SearchTable } from '../../components/utils/SearchTable';
import { useAlmacenes } from '../../../hooks/registros/useAlmacenes';



export const Almacenes = () => {
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"   
    const [isOpen, openModal, closeModal] = useModal()
    const idTablaAlmacenes = "tabla-almacenes";

    const {
        
    } = useAlmacenes()

    useEffect(() => {
    }, [])

    const almacenes = [
        {cod:"01", nombre: "T-MAN Almacen N°1", usuarioCreacion: "Admin@Pruebas", fechaCreacion:"05/01/2023 10:01:12",NomRuta:"301",Lado:"A"},
        {cod:"02", nombre: "T-MAN Almacen Carabayllo", usuarioCreacion: "Admin@Pruebas", fechaCreacion:"05/01/2023 10:01:12",NomRuta:"305",Lado:"B"},
        {cod:"03", nombre: "T-MAN Almacen San Juan de Lurigancho", usuarioCreacion: "Admin@Pruebas", fechaCreacion:"05/01/2023 10:01:12",NomRuta:"301",Lado:"A"},
        {cod:"04", nombre: "T-MAN Almacen Manchay", usuarioCreacion: "Admin@Pruebas", fechaCreacion:"05/01/2023 10:01:12",NomRuta:"586",Lado:"A"},
        {cod:"05", nombre: "T-MAN Almacen RutaB", usuarioCreacion: "Admin@Pruebas", fechaCreacion:"05/01/2023 10:01:12",NomRuta:"798",Lado:"B"},
    ]
        
        // tablaImportacion.push(repuestos)
        
        
    return (
        <>
            <ContenedorParametros
                titulo='Almacenes' tablaId={idTablaAlmacenes}
            >   
                <BotonProcesar></BotonProcesar>       
                <BotonNuevo onClick={openModal}></BotonNuevo>

            </ContenedorParametros>
            <Tooltip id={'Estado'}>Estado</Tooltip>
            <Tooltip id={'Categoria'}>Categoria</Tooltip>

            <div className="containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                <table id={idTablaAlmacenes} className="tableResponsive">
                    <thead>
                        <tr>
                            <th className="w-[20px]">N°</th>
                            <th className="w-[50%]">NOMBRE ALMACEN</th>
                            <th className="w-[200px]">USUARIO CREACION</th>
                            <th className="w-[250px]">FECHA CREACION</th>
                            <th className="w-[150px]">RUTA</th>
                            <th className="w-[150px]">LADO</th>
                            <th className="w-[150px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {   

                        almacenes.length > 0 
                        ? almacenes.map((almacen, i) => {
                            return (
                                <tr key={i+1} className=''>
                                    <td data-label="" className='tablenum text-center w-[20px]'> {++i}</td>
                                    <td data-label="Nombre" className="text-center w-[20px]">{almacen.nombre}</td>
                                    <td data-label="usuario Creacion" className="text-center w-[120px]">{almacen.usuarioCreacion}</td>
                                    <td data-label="Fecha Creacion" className="text-center w-[200px]">{almacen.fechaCreacion}</td>
                                    <td data-label="Ruta" className="text-center w-[150px]">{almacen.NomRuta}</td>
                                    <td data-label="Lado" className="text-center w-[150px]">{almacen.Lado}</td>
                                    <td data-label="Opciones" className="tableopciones text-center w-[10px] whitespace-nowrap" >
                                        <button className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded">
                                            <i className="fas fa-edit"></i>
                                        </button>
                                        <button  className="bg-red-500 hover:bg-red-800 text-[14px] px-[5px] py-1 rounded ml-3">
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            )
                        })
                        : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                    }
                    </tbody> 
                </table>
            </div>

            <Modal 
                isOpen={isOpen} closeModal={closeModal} action={{}}
                title="Registrar Almacen"
                spinner={{}}
            >
                <div className="w-[500px] lg:w-full px-4">
                    <div className="flex flex-col justify-between w-full form-content">                        
                        <div className='lg:flex-col lg:w-full'>
                            <label>Nombre Almacén </label>
                            <div className="flex items-center gap-4 w-[250px]">
                                <input className={`${classNameInput} caret-input`} />
                            </div>
                        </div>

                        <div className='lg:flex-col lg:w-full'>
                            <label>Ruta:  </label>
                            <div className="flex items-center gap-4 w-[250px]">
                                <select className={`${classNameInput} caret-input`}>
                                    <option> 145 </option>
                                    <option> 457 </option>
                                    <option> 478 </option>
                                </select>
                            </div>
                        </div>

                        <div className='lg:flex-col lg:w-full'>
                            <label>Lado: </label>
                            <div className="flex items-center gap-4 w-[250px]">
                                <select className={`${classNameInput} caret-input`}>
                                    <option> A </option>
                                    <option> B</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}